export default "__VITE_ASSET__DFGeb54o__"